<modal-form-container title="Edit tag" [showModal]="open" (closeModalEvent)="close()">
  <form class="gf" [formGroup]="tagForm" (ngSubmit)="handleSubmit()" novalidate>
    <div class="gf__grid">
      <input-field class="gf__wide" label="Name" [errorMessage]="nameError">
        <input class="input-style" formControlName="name" />
      </input-field>

      <input-field class="gf__wide" label="Description" hint="Optional. When to use this tag.">
        <textarea class="input-style" formControlName="description" rows="3"></textarea>
      </input-field>
    </div>

    @if (saveError) {
      <p class="gf__error" role="alert">
        <span class="bk-sym" aria-hidden="true">error</span>
        {{ saveError }}
      </p>
    }

    <div class="gf__foot">
      <customizable-button title="Cancel" (click)="close()" type="button" [outline]="true" />
      <customizable-button title="Save changes" type="submit" [loading]="contactServiceLoading" />
    </div>
  </form>
</modal-form-container>
